import { useMemo } from 'react';
import type { MasonryEngineNodeQueryParams } from '@leagueplatform/masonry-engine';

const canonicalize = (
  params: MasonryEngineNodeQueryParams | undefined,
): string | undefined => {
  if (!params) return undefined;
  const sorted = Object.keys(params)
    .sort()
    .reduce<Record<string, string>>((acc, key) => {
      acc[key] = params[key];
      return acc;
    }, {});
  return JSON.stringify(sorted);
};

/**
 * Returns a referentially-stable version of `initialQueryParams` so that
 * callers don't need to memoize the object they pass in.
 */
export const useStableQueryParams = (
  params: MasonryEngineNodeQueryParams | undefined,
): MasonryEngineNodeQueryParams | undefined => {
  const key = canonicalize(params);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => (key ? JSON.parse(key) : undefined), [key]);
};
